type ScrollAlign = 'nearest' | 'start';

const isScrollable = (element: HTMLElement): boolean => {
    const overflowY = window.getComputedStyle(element).overflowY;
    return (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay')
        && element.scrollHeight > element.clientHeight;
};

export const scrollIntoContainer = (element: HTMLElement | null, align: ScrollAlign = 'nearest') => {
    if (!element) {
        return;
    }

    let container = element.parentElement;
    while (container && container !== document.body && !isScrollable(container)) {
        container = container.parentElement;
    }
    if (!container || container === document.body) {
        return;
    }

    const elementBox = element.getBoundingClientRect();
    const containerBox = container.getBoundingClientRect();
    const fullyVisible = elementBox.top >= containerBox.top && elementBox.bottom <= containerBox.bottom;

    if (align === 'nearest' && fullyVisible) {
        return;
    }

    const delta = align === 'start' || elementBox.top < containerBox.top
        ? elementBox.top - containerBox.top
        : elementBox.bottom - containerBox.bottom;

    container.scrollTo({ top: container.scrollTop + delta, behavior: 'smooth' });
};
